import React, { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { useApp } from "@/state/AppContext";
import { Button } from "@/components/ui/button";

export function InstallAppButton() {
  const { t } = useApp();
  const [prompt, setPrompt] = useState(null);

  useEffect(() => {
    const handler = (event) => {
      event.preventDefault();
      setPrompt(event);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  // `beforeinstallprompt` only fires when the app is installable and NOT already installed, so
  // the presence of a prompt is the whole gate — nothing further is needed to hide this once the
  // site is running standalone.
  if (!prompt) return null;

  return (
    <Button
      variant="outline"
      size="sm"
      /* Was `hidden … sm:flex`, which hid add-to-home-screen on exactly the widths where a PWA
       * install is the point. Now it shows everywhere; the label collapses to the icon alone
       * below sm so the header row does not overflow next to SOS, the bell and the cart. */
      className="flex gap-1 rounded-full"
      aria-label={t("pwa.install")}
      data-testid="install-app-btn"
      onClick={async () => {
        prompt.prompt();
        await prompt.userChoice;
        setPrompt(null);
      }}
    >
      <Download size={14} />
      <span className="hidden sm:inline">{t("pwa.install")}</span>
    </Button>
  );
}
